// extracted by mini-css-extract-plugin
export default {"title_mobile":"Verification_title_mobile__aEd4O","title_desktop":"Verification_title_desktop__yi-yI","submitButton":"Verification_submitButton__CSrvi"};